<template>
  <v-dialog v-model="loading" hide-overlay :persistent="!disablePersistent" width="250">
    <v-card color="primary">
      <v-card-text class="loading-dialog-text">
        {{text || 'Please stand by'}}
        <v-progress-linear indeterminate color="secondary" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'LinearProgress',
    props: {
      loading: Boolean,
      text: String,
      disablePersistent: Boolean
    }
  }
</script>

<style scoped>
.loading-dialog-text {
  color: var(--ims-color-secondary) !important;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// LinearProgress.vue?4f7bb9f2